import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import { Menu } from "Models/Menu";
import * as React from "react";
import { connect } from "react-redux";
import { IAuthenticationState } from "Store/Authentication/AuthenticationActionTypes";
import { IApplicationState } from "Store/Store";
import i18n from "Translations/i18n";
import styles from "./MenuItem.scss";

interface IProps {
    item: Menu;
    selected?: boolean;
    authenticationState: IAuthenticationState;
}

interface IState {
    item: Menu;
    selected?: boolean;
    authenticationState?: IAuthenticationState;
}

const mapStateToProps = (state: IApplicationState) => ({
    authenticationState: state.authenticationState
});

export class MenuItem extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            item: props.item,
            selected: props.selected
        };
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState | null> {
        if (nextProps.authenticationState !== prevState.authenticationState) {
            return { authenticationState: nextProps.authenticationState };
        }
        return null;
    }

    public render() {
        if (!this.state.authenticationState || !this.state.authenticationState.login ||
            (this.state.item.allowedRoles.length !== 0 && this.state.item.allowedRoles.indexOf(this.state.authenticationState.login.user.role) === -1)) {
            return null;
        }

        return (
            <RouterLink to={this.props.item.url} type={RouterLinkType.default}>
                <div id={`btnMenu${this.props.item.key}`} title={i18n.t("menu." + this.props.item.key)} className={`${styles.menuItem} ${this.props.selected ? styles.selected : ""}`}>
                    <span className={styles.title}>{i18n.t("menu." + this.props.item.key)}</span>
                </div>
            </RouterLink>
        );
    }
}

export default connect(mapStateToProps)(MenuItem);


// WEBPACK FOOTER //
// ./src/Components/Header/MenuItem/MenuItem.tsx